import { View } from "extensions/marionette";
import $ from "jquery";
import { FloatLabels } from "extensions/floatLabels";

import { authentication } from "common/config/api";
import strings from "common/strings";
import {
    destroyPopovers
} from "common/utils";

import { request } from "common/components/request";
import { Dialog } from "common/components/dialog/dialog";

import loaderTemplate from "common/helpers/horizontal-loader.jst";

import loginTemplateFrame from "./templateFrame.jst";
import resetPasswordRequestTemplate from "./resetPasswordRequest.jst";

export const ResetPasswordRequestView = View.extend({
    waiting: false,
    template: (data) => loginTemplateFrame({
        partial: resetPasswordRequestTemplate,
        ...data
    }),
    ui: {
        form: "#merchant-login-form",
        "global-error": "#reset-status",
        "email-error": ".email-error",
        resetButton: ".btn-primary",
        success: "#reset-status-success",
        email: "#email"
    },
    events: {
        "submit @ui.form": "resetPassword",
        "click .no-email-access-popup": "showNoEmailFAQ"
    },
    
    showNoEmailFAQ(e) {
        Dialog.show({
            title: strings.login.troubleSignIn,
            dismissable: true,
            backdrop: "static",
            content: () => strings.login.cantLogin,
            render: true
        });
        
        e.preventDefault();
    },
    
    hideOpenAlert() {
        // noinspection JSUnresolvedFunction
        this.$(".alert:visible").addClass("hidden");
    },
    
    onUnauthorized(error) {
        const errorCont = this.ui["global-error"];
        
        this.hideOpenAlert();
        
        // Display error in appropriate box
        errorCont.html(error).removeClass("hidden");
        
        // Remove spinner
        this.removeSpinnerFromResetButton();
        
        return error;
    },
    
    onAuthorized() {
        // Empty placeholder
        this.waiting = false;
        this.hideOpenAlert();
        
        // Display check instructions message in appropriate box
        this.ui.success.removeClass("hidden");
        
        // Trigger reset on the form to clean email and re-init floating labels
        this.ui.form.trigger("reset");
        
        // Remove spinner
        this.removeSpinnerFromResetButton();
    },
    
    addSpinnerToResetButton() {
        this.waiting = true;
        const $loading = $(loaderTemplate()).find(".loading-spinner").addClass("white").end();
        this.ui.resetButton.html($loading);
    },
    
    removeSpinnerFromResetButton() {
        this.waiting = false;
        this.ui.resetButton.html(strings.login.resetPassword);
    },
    
    resetPassword(event) {
        event.preventDefault();
        if (this.waiting) {
            return;
        }
        
        const { email } = Object.fromEntries(new FormData(this.ui.form[0]));
        this.addSpinnerToResetButton();
        
        this.doReset({
            email,
            onUnauthorized: this.onUnauthorized.bind(this),
            onAuthorized: this.onAuthorized.bind(this)
        });
    },
    
    doReset(opts) {
        destroyPopovers();
        
        // Do some pre-checks
        if (!opts.email.trim().length) {
            return opts.onUnauthorized(strings.login.errors.emailEmpty);
        }
        
        return request(authentication.password.reset, {
            data: {
                email: opts.email
            },
            ensureAuth: false,
            method: "POST"
        }).then(() => {
            if (typeof opts.onAuthorized === "function") {
                opts.onAuthorized();
            }
        }).catch((error) => {
            // Don't show message that we don't have the user in DB
            opts.onUnauthorized(strings.login.errors.resetError);
        });
    },
    
    onAttach() {
        this.floatLabelInstance = new FloatLabels("#merchant-login-form", {
            style: 2
        });
    
        this.ui.email.focus();
    },
    
    templateContext() {
        return {
            email: this.getOption("email"),
            reason: this.getOption("reason")
        };
    }
});
